import { Moment } from 'moment';

export class Session {
  token: string;
  expiredInMinutes: number;
  expiredDate: Moment;
}
